<template>
  <div class="flex flex-wrap diygw-col-24 flex-direction-column flex20-clz">
    <div class="flex flex-wrap diygw-col-24 flex-direction-column flex21-clz">
<!--      <div class="diygw-col-24 text37-clz">DEEP</div>-->
<!--      <div class="diygw-col-24 text38-clz">Contact Us</div>-->
      <div class="diygw-col-24 text39-clz">联系我们</div>
    </div>
    <div class="flex flex-wrap diygw-col-24 justify-center flex23-clz">
      <a class="flex diygw-autoview diygw-col-24 autoview-clz" @click="openWxChat">
        <div class="diygw-absolute autoview_0">
          <span class="flex icon diygw-col-24 icon-clz diy-icon-weixin"></span>
        </div>
        <div class="diygw-absolute autoview_1">
          <div class="diygw-col-24 text40-clz">微信公众号</div>
        </div>
      </a>
      <a class="flex diygw-autoview diygw-col-24 autoview-clz" @click="openWxChat">
        <div class="diygw-absolute autoview_0">
          <span class="flex icon diygw-col-24 icon-clz diy-icon-weixin"></span>
        </div>
        <div class="diygw-absolute autoview_1">
          <div class="diygw-col-24 text40-clz">微信</div>
        </div>
      </a>
      <a class="flex diygw-autoview diygw-col-24 autoview-clz" @click="openXhs">
        <div class="diygw-absolute autoview_0 diy-icon-xiaohongshu">
          <img src="https://crmh5.lightcourse.com/dt/xiaohongshu.png" />
<!--          <span class="flex icon diygw-col-24 icon-clz "></span>-->
        </div>
        <div class="diygw-absolute autoview_1">
          <div class="diygw-col-24 text40-clz">小红书</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    props: {

    },
    components:{
    },
    data(){
      return{
        updateYear: null,
      }
    },
    created() {
      let copyright = new Date();
      this.updateYear = copyright.getFullYear();
    },
    methods: {
      openXhs() {
        window.open("https://www.xiaohongshu.com/user/profile/5e0f5f7f0000000001007aaf?xhsshare=CopyLink&appuid=642e38a3000000001400fc8a&apptime=1707272765",
            "_blank");
      },
      openGzh() {
        window.open("https://mp.weixin.qq.com/s?__biz=MzA5ODE0MTYyMw==&mid=2247505906&idx=1&sn=f02c5d9472acb750b2ad11f539f8e3a0&chksm=9094832aa7e30a3c3368e4d0211f4192b6117b9cc3d55b26ea80652d35203e81b948fde54d33#rd", "_blank");
      },
      openWxChat() {
        window.open("https://work.weixin.qq.com/ca/cawcde8ab11d1bc557", "_blank");
      },
      copyText(value) {
        let input = document.createElement("input"); // 创建input对象
        input.value = value; // 设置复制内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        layer.msg("Copy Succeeded");
      },
      showChatQr() {
        this.$refs.qrCode.showChatQr();
      },
    }
  }
</script>

<style scoped>
  .diy-icon-xiaohongshu {
    width: 152px !important;
    left: 0 !important;
  }
  .diy-icon-xiaohongshu img{
    width: 152px;
    height: 60px;
  }
  .flex20-clz {
    background-color: #e83928;
    padding-top: 60px;
    padding-left: 0px;
    padding-bottom: 60px;
    padding-right: 0px;
  }
  .text37-clz {
    color: #ffffff;
    font-weight: bold;
    font-size: 28px !important;
    text-align: center;
  }
  .text38-clz {
    color: #ffffff;
    font-weight: bold;
    font-size: 50px !important;
    text-align: center;
  }
  .text39-clz {
    margin-left: 0px;
    color: #ffffff;
    width: 100% !important;
    font-size: 26px !important;
    margin-top: 5px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  .flex23-clz {
    margin-left: 0px;
    width: 100% !important;
    margin-top: 30px;
    margin-bottom: 15px;
    margin-right: 0px;
  }
  .autoview-clz {
    flex-shrink: 0;
    z-index: 1000;
    width: 140px !important;
    height: 100px;
  }

  .autoview_0 {
    left: 36px;
    top: 0px;
    width: 63px;
    height: 99px;
    z-index: 0;
  }
  .autoview_0 > .flex {
    height: 100%;
  }
  .autoview_1 {
    left: 0px;
    top: 60px;
    width: 139px;
    height: 40px;
    z-index: 0;
  }
  .autoview_1 > .flex {
    height: 100%;
  }
  .icon-clz {
    color: #ffffff;
  }
  .icon {
    font-size: 60px;
  }
  .text40-clz {
    margin-left: 0px;
    color: #ffffff;
    width: 100% !important;
    font-size: 15px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  @media screen and (max-width: 900px) {
    .autoview-clz,.autoview_1 {
      width: 110px !important;
    }
    .text40-clz {
      font-size: 14px !important;
    }
    .text39-clz {
      font-size: 20px !important;
    }
    .icon {
      font-size: 40px;
    }
    .diy-icon-xiaohongshu {
      width: 102px !important;
      left: 5px !important;
    }
    .diy-icon-xiaohongshu img{
      width: 102px;
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/ChatFooter.vue